import React from 'react';
import {ArrowUpIcon} from '@heroicons/react/24/outline';
import {useCurrentClientQuery} from 'api';
import useSearchParams from '../useSearchParams';

export type SortField = 'converted_at' | 'total_score';
export type SortOrder = 'asc' | 'desc';

const Sort: React.FC = () => {
  const {query, setQuery} = useSearchParams();
  const sortField = query.sortField || 'converted_at';
  const sortOrder = query.sortOrder || 'desc';

  const handleSortFieldChange = (field: SortField) => {
    setQuery({
      sortField: field,
      page: 1,
    });
  };

  const handleSortOrderToggle = () => {
    setQuery({
      sortOrder: sortOrder === 'desc' ? 'asc' : 'desc',
      page: 1,
    });
  };
  const {data: {currentClient: {currentScoreContract = {}} = {}} = {}} =
    useCurrentClientQuery();

  const sortOptions = [
    {value: 'converted_at', label: '登録日'},
    ...(currentScoreContract?.isActive
      ? [{value: 'total_score', label: 'スコア'}]
      : []),
  ];

  return (
    <div className="flex items-center">
      <select
        value={sortField}
        onChange={(e) => handleSortFieldChange(e.target.value as SortField)}
        className="w-32 block form-select appearance-none bg-white border-border rounded-l !rounded-r-none focus:outline-none text-sm text-foreground h-10"
      >
        {sortOptions.map((option) => (
          <option key={option.value} value={option.value}>
            {option.label}
          </option>
        ))}
      </select>
      <button
        onClick={handleSortOrderToggle}
        className={
          'border border-border rounded-r rounded-l-none hover:bg-background-hover hover:cursor-pointer flex items-center justify-center transition-all duration-200 w-16 h-10 bg-white'
        }
      >
        <div>
          <ArrowUpIcon
            className={`w-3 h-3 transition-transform duration-200 ${
              sortOrder === 'desc' ? 'rotate-180' : 'rotate-0'
            }`}
          />
        </div>
        <span className="text-sm ml-1">
          {sortOrder === 'desc' ? '降順' : '昇順'}
        </span>
      </button>
    </div>
  );
};

export default Sort;
